export const useBrowserInfo = () => {
  const getBrowserInfo = (): { name: string, version: string } => {
    const ua = navigator.userAgent
    let name = 'Unknown'
    let version = 'Unknown'

    // Detect browser and extract version
    if (ua.includes('Edg/')) {
      name = 'Microsoft Edge (Chromium)'
      version = extractVersion(ua, 'Edg/')
    } else if (ua.includes('OPR/') || ua.includes('Opera/')) {
      name = 'Opera'
      version = ua.includes('OPR/')
        ? extractVersion(ua, 'OPR/')
        : extractVersion(ua, 'Opera/')
    } else if (ua.includes('Chrome/')) {
      name = 'Google Chrome'
      version = extractVersion(ua, 'Chrome/')
    } else if (ua.includes('Firefox/')) {
      name = 'Mozilla Firefox'
      version = extractVersion(ua, 'Firefox/')
    } else if (ua.includes('Safari/')) {
      name = 'Apple Safari'
      version = ua.includes('Version/')
        ? extractVersion(ua, 'Version/')
        : extractVersion(ua, 'Safari/')
    } else if (ua.includes('Trident/')) {
      name = 'Internet Explorer'
      version = extractVersion(ua, 'rv:')
    }

    return { name, version }
  }

  const extractVersion = (ua: string, token: string) => {
    const index = ua.indexOf(token)
    if (index === -1) return 'Unknown'
    const sub = ua.substring(index + token.length)
    const match = sub.match(/^\d+(\.\d+)*/) // Match numeric versions (X, X.Y, X.Y.Z)
    return match ? match[0] : 'Unknown'
  }

  return { getBrowserInfo }
}
